<div class="app-container">
    <div class="grid-wrapper">
        <div
            #gridRef
            id="grid"
            class="grid grid-content--lg"
            (drop)="onDrop($event)"
            (dragover)="onGridDragOver($event)">
            @for (item of items(); track item.id; let i = $index) {
                <div
                    [id]="'c' + item.id"
                    [ngClass]="getCellClasses(item)"
                    [attr.draggable]="draggable() ? 'true' : null"
                    [attr.data-slot-idx]="getSlotIdx(item)"
                    [style.borderColor]="getCellBorderColor(item)"
                    (dragstart)="onDragStart($event, item)"
                    (dragend)="onDragEnd()">
                    <div class="cell-inner">
                        <ntv-thumbnail-item
                            [item]="item"
                            [size]="'xl'"
                            [disableRightClick]="true"
                            [style.pointer-events]="
                                draggable() ? 'none' : 'auto'
                            "></ntv-thumbnail-item>
                    </div>
                </div>
            }
        </div>

        <!-- Overlays -->
        <div id="overlays" style="position: absolute; inset: 0; pointer-events: none; z-index: 3">
            @for (ov of overlays(); track ov.key) {
                <div
                    class="block-overlay"
                    [style.left]="ov.x + 'px'"
                    [style.top]="ov.y + 'px'"
                    [style.width]="ov.w + 'px'"
                    [style.height]="ov.h + 'px'"
                    [style.background]="ov.background"
                    [style.borderTop]="ov.borderTop"
                    [style.borderBottom]="ov.borderBottom"
                    [style.borderLeft]="ov.borderLeft"
                    [style.borderRight]="ov.borderRight"
                    [style.borderRadius]="ov.borderRadius">
                    @if (ov.isFirst) {
                        <div class="block-tag" [style.background]="ov.color">{{ ov.label }}</div>
                    } @else {
                        <div class="block-continuation" [style.color]="ov.color">
                            ↳ {{ ov.label }}
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <!-- Custom Ghost -->
    @if (draggingSlotIdx() !== null && ghostSlot) {
        <div
            id="custom-ghost"
            [style.left]="ghostStyle['left']"
            [style.top]="ghostStyle['top']"
            style="display: block">
            <!-- Solo ghost -->
            @if (ghostSlot.type === 'solo') {
                <div class="ghost-solo cell">
                    <div class="cell-inner">
                        <div class="cell-content">{{ ghostSlot.item.name }}</div>
                        <div class="cell-type-tag">solo</div>
                    </div>
                </div>
            }

            <!-- Block ghost -->
            @if (ghostSlot.type === 'block') {
                <div class="ghost-block-wrap">
                    <div
                        class="ghost-block-label"
                        [style.background]="getBlockDef(ghostSlot.blockId).color">
                        {{ getBlockDef(ghostSlot.blockId).label }}
                    </div>
                    <div
                        class="ghost-grid"
                        [style.gridTemplateColumns]="ghostGhostGridCols(ghostSlot)">
                        @for (gItem of ghostShownItems(ghostSlot); track gItem.id) {
                            <div
                                class="cell in-block"
                                [class.is-channel]="gItem.isChannel"
                                [style.borderColor]="getBlockDef(ghostSlot.blockId).color + '55'"
                                style="height: 100px">
                                <div class="cell-inner">
                                    <div class="cell-content">{{ gItem.name }}</div>
                                </div>
                            </div>
                        }
                        @if (ghostExtraCount(ghostSlot) > 0) {
                            <div
                                class="ghost-cell"
                                [style.borderColor]="getBlockDef(ghostSlot.blockId).color + '44'"
                                [style.color]="getBlockDef(ghostSlot.blockId).color"
                                style="border-style: dashed">
                                +{{ ghostExtraCount(ghostSlot) }} more
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }

    <!-- Blank canvas for suppressing native drag ghost -->
    <canvas #blankCanvas id="blank-ghost" width="1" height="1"></canvas>

    <!-- Toast -->
    <div class="toast" [class.show]="toast() !== null">{{ toast() }}</div>
</div>
